var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHistogram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 19.5H10.5C10.7983 19.4997 11.0842 19.381 11.2951 19.1701C11.506 18.9592 11.6247 18.6733 11.625 18.375V8.625C11.6247 8.32674 11.506 8.04079 11.2951 7.82989C11.0842 7.61899 10.7983 7.50035 10.5 7.5H6.375C6.07674 7.50035 5.79079 7.61899 5.57989 7.82989C5.36899 8.04079 5.25035 8.32674 5.25 8.625V18.375C5.25035 18.6733 5.36899 18.9592 5.57989 19.1701C5.79079 19.381 6.07674 19.4997 6.375 19.5ZM6.75 9H10.125V18H6.75V9Z",
    fill: "#848B9F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.875 0.75H15.75C15.4517 0.750347 15.1658 0.868985 14.9549 1.07989C14.744 1.29079 14.6253 1.57674 14.625 1.875V18.375C14.6253 18.6733 14.744 18.9592 14.9549 19.1701C15.1658 19.381 15.4517 19.4997 15.75 19.5H19.875C20.1733 19.4997 20.4592 19.381 20.6701 19.1701C20.881 18.9592 20.9997 18.6733 21 18.375V1.875C20.9997 1.57674 20.881 1.29079 20.6701 1.07989C20.4592 0.868985 20.1733 0.750347 19.875 0.75ZM19.5 18H16.125V2.25H19.5V18Z",
    fill: "#848B9F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.25 0.75H0.75V23.25H23.25V21.75H2.25V0.75Z",
    fill: "#848B9F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistogram);
export default __webpack_public_path__ + "static/media/histogram.d2a11fa8.svg";
export { ForwardRef as ReactComponent };